const shared = {
  common: {
    yes: 'Yes',
    no: 'No',
    update: 'Update',
    edit: 'Edit',
    language: 'En',
    errorMsg: 'Error loading data...',
    loadingMsg: 'loading',
    canada: {
      provinces: {
        'All Provinces': 'All Provinces',
        Alberta: 'Alberta',
        'British Columbia': 'British Columbia',
        Manitoba: 'Manitoba',
        'New Brunswick': 'New Brunswick',
        'Newfoundland and Labrador': 'Newfoundland and Labrador',
        'Northwest Territories': 'Northwest Territories',
        'Nova Scotia': 'Nova Scotia',
        Nunavut: 'Nunavut',
        Ontario: 'Ontario',
        'Prince Edward Island': 'Prince Edward Island',
        Quebec: 'Quebec',
        Saskatchewan: 'Saskatchewan',
        Yukon: 'Yukon',
        International: 'International'
      }
    },
    gender: {
      m: 'Male',
      f: 'Female'
    },
    preferedLanguage: {
      ENGLISH: 'English',
      FRENCH: 'French'
    }
  }
}

export default shared
